<template >
    <div class="garyaBg montserrat overflow-hidden">
    <!-- Hero Section -->
    <section class="text-white flex flex-row justify-center  items-center md:max-w-full max-h-full h-full background-1566">
  <div class="container md:mx-auto  md:py-44 lg:py-24">
    <div class="flex flexmobile2">
      <div class="lg:w-full mb-8 lg:mb-0">
          <h1 class="text-3xl sm:text-md md:text-5xl  font-bold mb-6">
            Eater Chicago
                  </h1>
          <h2 class="text-2xl md:text-4xl  font-medium">
            Usability Evaluation Study
          </h2>
        </div>
      <div class="w-full h-full  animate__animated animate__zoomInRight">
        <img
        loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/d1e36abf917328d65267d5c4bce051fc3be04dd85ad46a5276dcaeb1858f486b?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b"
          alt="Eater Chicago website mockup"
          class=" w-[70%] md:w-full max-w-md  md:max-w-2xl mx-auto"
        />
      </div>
    </div>
  </div>
</section>


    <!-- My Role Section -->
    <section class="flexmobile2 text-white mx-auto  md:mx-auto md:px-4 md:py-12">
  <div class="flex flexmobile2 flex-col lg:flex-row justify-between">
    <div class="md:w-full lg:w-1/2 mb-8 lg:mb-0">
      <h1 class="self-start text-4xl font-semibold text-white ml-16">My Role</h1>
      <p class="pt-8 text-lg text-white ml-16">
        Performed <span class="text-yellow-400">Heuristic Evaluation</span> and <span class="text-yellow-400">Cognitive Walkthrough</span> of the website<br /><br />
        Identified intended user task and <span class="text-yellow-400">pinpointed bottlenecks</span><br /><br />
        Conducted <span class="text-yellow-400">Observation studies</span> with eligible participants to better understand their expectations<br /><br />
        Suggested <span class="text-yellow-400">Design Recommendations based on priority</span> to improve the website's usability
      </p>
    </div>
    <div class="hiddenn">
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726676159/Line_1_fhhb8m.png" alt="Horizontal Line">

    </div>
    <aside class="w-full lg:w-1/4">
      <div class=" pl-4">
        <h1 class="self-start text-4xl font-semibold text-white">Duration</h1>
        <p class="pt-4 text-lg  text-amber-50">8 weeks</p>
        <h1 class="self-start text-4xl font-semibold text-white pt-8">Group of 3</h1>
        <h1 class="self-start text-4xl font-semibold text-white pt-12">Tools</h1>
        <p class="pt-6 text-lg  text-white">Zoom, Google Docs, Miro</p>
      </div>
    </aside>
  </div>
</section>

    <!-- About Section -->
    <section id="about" class=" flexmobile2  md:mx-auto md:px-4 md:py-10">
  <h1 class="self-start text-4xl font-semibold text-white ml-16">About</h1>
  <p class="pt-6 text-lg md:pt-16 text-white ml-16">
    Eater is a popular website that covers the dining and food culture of various cities worldwide. The website provides restaurant reviews, food and drink news, features on local chefs and trends, and guides to dining out.
    <br /><br />
    <a href="https://chicago.eater.com/" class="text-red-600 underline" target="_blank" rel="noopener noreferrer">Eater Chicago</a> is the Eater website's section dedicated to Chicago.<br /><br />
    By visiting the Eater Chicago website, readers can explore articles and recommendations about new <span class="text-yellow-400">restaurant openings, chef profiles, food events, recipes</span> and other food-related topics specific to Chicago.<br /><br />
    The site often includes detailed reviews of popular restaurants, along with information on their <span class="text-yellow-400">menus, ambience, and overall dining experience.</span>
  </p>
</section>


      <!-- fourth section -->
      <section class=" mt-32  flexmobile2  md:mx-auto md:px-4 md:py-2">
  <div class="md:w-full flexmobile2   max-w-full">
    <!-- Heading -->
    <h1 class="self-start text-4xl font-semibold text-white ml-16">Current Website & its Navigation</h1>
    <!-- First Image -->
    
  </div>
</section>


<!-- Second Image -->
<section class="flex container mx-auto flexmobile2 w-[90%]  mt-10 md:mt-10  justify-center items-center flex-col rounded-none">
  <div class="relative justify-center items-center">
      <!-- Image mockup -->
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726657414/MacBook_Pro_awxwkk.png" alt="MacBook Mockup" class="mockup-image">
      <!-- Video overlay -->
      <video
        class="   w-[100%] absolute h-[85.6%] top-2   md:top-8  "
        autoplay
        muted
        loop
      >
        <source src="/assets/eater.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </section>

  <section class=" w-full p-0 m-0 mt-14 md:mt-96">
    <img src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1727033710/Subject_50_cttbtm.png" alt="">
  </section>
 <!-- goal comp ol -->
 <div class="relative ">
  <!-- Fifth section -->
  <section class="flex flexmobile2 h-full background-4198 flex-col items-start px-5 md:px-20 pt-24 md:pt-52 pb-24 md:pb-28 mt-10 md:mt-72 w-full  max-md:max-w-full">
   <section class="  mx-auto">
    <h1 class="self-start text-4xl font-semibold text-white -ml-4">Goal</h1>
    <ol class="pt-6 text-lg md:pt-12 list-decimal mb-2.5  text-white w-full md:w-[1245px] max-md:max-w-full">
      <li >
        <span class="pt-6 text-lg ">Assess the overall effectiveness of </span>
        <a href="https://chicago.eater.com/" class="font-medium underline" target="_blank" rel="noopener noreferrer">Eater Chicago</a>
        <span class="pt-6 text-lg "> for different types of users performing common tasks.</span>
      </li>
      <li class=" pt-6 text-lg ">
        <span class="pt-6 text-lg ">Identify obstacles to finding restaurant recommendations on the site.</span>
      </li>
      <li class="pt-6 text-lg ">
        <span class="pt-6 text-lg ">Assessing the website to see if it satisfies user expectations and standards.</span>
      </li>
    </ol>
   </section>
   <section class="flex flex-col items-start  px-5 pt-40 pb-24 md:pb-40 w-full max-md:max-w-full">
    <h1 class="self-start text-4xl font-semibold text-white">Research Questions</h1>
    <ol start="1" class=" list-decimal  pt-6 text-lg  text-white w-full md:w-[1245px] max-md:max-w-full ml-4">
      <li class=" pt-6 text-lg ">What are the major usability flaws that restrict users from completing common tasks?</li>
      <li class=" pt-6 text-lg ">How does the organization and structure of the website match users' expectations?</li>
      <li class=" pt-6 text-lg ">How easily and successfully can users find restaurant recommendations based on their unique criteria?</li>
      <li class=" pt-6 text-lg ">How satisfied are the users with the presented recommendations?</li>
    </ol>
  </section>
  </section>

 
</div>

<div class=" flex  md:mb-20 flexmobile2 justify-center animate__animated animate__zoomInDown">
  <img loading="lazy" class="md:max-w-[700px] flexmobile2" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726676082/Subject_9_4_osiqxm.png" alt="">
</div>

      <!-- seventh -->
      <section class="flex  mx-auto flexmobile2 mt-24 flex-col px-5 md:px-20 pt-20  w-full max-md:max-w-full rounded-none">

     <h1 class="self-start text-4xl font-semibold text-white"> Preliminary Research</h1>
  </section>
      <section class="flex container mx-auto flexmobile2 mt-4 flex-col px-5 md:px-20 pt-20 pb-24 md:pb-40 w-full max-md:max-w-full rounded-none">
  
  <div class="flex flex-wrap gap-5 justify-between items-center w-full max-w-full ">
    <article class="flex flex-col self-stretch ">
      <p class="text-yellow-400 text-2xl md:text-3xl font-semibold ">Heuristic Evaluation</p>
      <div class="pt-6 text-lg   text-white max-md:max-w-full">
        <p class=" pt-6 text-lg ">Identified major issues related to:</p>
        <ul class=" pt-6 text-lg  list-disc ml-8">
          <li class="pt-6 text-lg ">Consistency and Standards</li>
          <li class="pt-6 text-lg ">Lack of navigational cues</li>
        </ul>
      </div>
      
    </article>
    <div >
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726676159/Line_1_fhhb8m.png" alt="Horizontal Line">

    </div>
    <article class="flex flex-col  my-auto max-md:max-w-full -mt-8">
      <p class=" text-yellow-400 text-2xl md:text-3xl font-semibold pt-6"> Cognitive Walkthrough</p>
      <div class="pt-6 text-lg  text-white  max-md:max-w-full">
        <p class=" pt-6 text-lg ">Identified <span class="text-yellow-400">learnability issues</span> like:</p>
        <ul class=" list-disc ml-12">
          <li class=" pt-6 text-lg ">Endless scrolling to find relevant information</li>
          <li class=" pt-6 text-lg ">Lack of navigational cues</li>
          <li class=" pt-6 text-lg ">Missing filter options</li>
        </ul>
      </div>
    </article>
  </div>
</section>

      <!-- eaighth  -->
      <section class="flex   flexmobile2 flex-col pl-5 md:pl-20 w-full  max-md:max-w-full">
  <header class="flex flexmobile2 flex-wrap gap-5 justify-between  max-md:max-w-full">
    <div class="flex    flex-col max-md:max-w-full">
      <h1 class="self-start text-4xl font-semibold text-white">  Usability Testing Method</h1>
      <div class="flex mx-auto container flex-col items-start  md:mt-14 md:text-2xl max-md:max-w-full">
        <p class="max-md:max-w-ful pt-6 text-lg  text-white ">
          Conducted using <span class="text-yellow-400">within subjects</span> design.<br /><br />
          Recruited <span class="text-yellow-400">6</span> participants.<br /><br />
          Conducted individual study that lasted for <span class="text-yellow-400">45 minutes</span> each.<br /><br />
          Asked to perform <span class="text-yellow-400">4 key tasks</span> in <span class="Heuristic Evaluation">counter balance order.</span>
        </p>
        <section>
        <h1 class="self-start text-4xl font-semibold text-white pt-40">Participant Characteristics</h1>
        <p class="  pt-6 text-lg md:pt-16 text-white max-md:max-w-full">
          Eligible participants for this study must be:
        </p>
        <ol class="self-stretch pt-6 text-lg  text-white list-decimal   md:ml-9 max-md:max-w-full">
          <li class="pt-6">18+ years of age</li>
          <li class="pt-6">Residents of Chicago</li>
          <li class="pt-6">Visiting restaurants/bars frequently (at least twice a month)</li>
          <li class="pt-6">Actively looking for restaurant/bar recommendations</li>
          <ol start="4" class="list-decimal ml-6">
            <li class="list-dotted pt-6">Based on criteria such as location, budget, cuisine, ambience, etc.</li>
          </ol>
          <li class="pt-6">Looking to try new recipes at home</li>
        </ol>
        </section>
      </div>
    </div>
    <div ref="imageContainer" class="image-container -mt-8">
      <img
        loading="lazy"
        :src="imageUrl"
        alt="Illustration related to usability testing"
        :class="[ animateClass]"
        class="object-contain shrink-0 md:my-auto md:max-w-full md:aspect-[0.62] md:w-[388px]"
      />
    </div>
  </header>

  <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/8972e09a34dd1c040d38e77b385189bee653f5147395fa7940d3514252d12593?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Diagram or chart related to usability testing" class="object-contain animate__animated animate__zoomInRight self-center mt-10 md:mt-32 max-w-full aspect-[1] w-[300px] md:w-[700px]" />
  
  <div class="mx-auto  md:px-20 mt-10 md:mt-56 -ml-12">
    <h1 class="self-start text-4xl font-semibold text-white">Task List</h1>
    <p class="self-start  ml-2.5 pt-6 text-lg md:pt-16 text-white ">
      The following tasks were given to all the six participants:
    </p>
    <h3 class="self-start mt-10 ml-5 md:ml-16 text-2xl md:text-3xl font-semibold pt-6 text-yellow-400">
      Task 1: Find restaurant recommendations based on location
    </h3>
    <p class="relative  md:left-16  pt-6 text-lg  text-amber-50">
      "Your friend recently moved to Chicago and is living in Lincoln Park. Since she is new to the area, you decide to take her out to dinner somewhere close to her home. How would you use Eater Chicago to find a suitable restaurant?"
    </p>
    <h3 class="self-start mt-10 ml-5 md:ml-16 text-2xl md:text-3xl font-semibold pt-6 text-yellow-400">
      Task 2: Find restaurant recommendations for a certain cuisine
    </h3>
    <p class="relative left-4 md:left-16 pt-6 text-lg text-amber-50 ">
      "The same friend has explored Chicago and learned about its large Polish community. She's never tried Polish food and invites you to join her. How would you use Eater Chicago to find authentic Polish food?"
    </p>
    <h3 class="self-start mt-10 ml-5 md:ml-16 text-2xl md:text-3xl font-semibold pt-6 text-yellow-400">
      Task 3: Find restaurant recommendations based on ambience and budget
    </h3>
    <p class="relative left-4 md:left-16 pt-6 text-lg  text-amber-50">
      "It's a bright summer Sunday in the city of Chicago. Your friends want to experience an outdoor lunch on a budget. How would you use the Eater Chicago website to find a suitable spot?"
    </p>
    <h3 class="self-start mt-10 ml-5 md:ml-16 text-2xl md:text-3xl font-semibold pt-6 text-yellow-400">
      Task 4: Find a particular recipe on the website
    </h3>
    <p class="relative left-4 md:left-16 pt-6 text-lg  text-amber-50">
      "Last week, your friend made a French omelet for you. You recall him mentioning the recipe's source, Eater Chicago. How would you use the website to look for the recipe?"
    </p>
  </div>

  <section class="flex  flexmobile2 justify-between items-end  text-white mt-40">
    <div >
      <img class="relative md:max-w-lg right-10 md:right-20 h-full" src="https://res.cloudinary.com/dvkj5orhe/image/upload/v1731289274/mfliz1nqz99jfcdwb4vt.png" alt="">
    </div>
    <div class=" bottom-44 relative mr-24">
    <h1 class="self-start text-4xl font-semibold text-white">Evaluation Measures</h1>
      <p class=" pt-6 text-lg md:pt-16 text-white w-full md:w-[620px]">
        The following measures were observed and evaluated for each task to determine Eater Chicago's current usability standard:
      </p>
      <ul class="pt-6 text-lg list-disc max-md:max-w-full">
        <li class="pt-4">Percentage of participants performing the task successfully</li>
        <li class="pt-4">Time taken to complete the task</li>
        <li class="pt-4">Number of articles browsed</li>
        <li class="pt-4">Perceived difficulty of the task</li>
        <li class="pt-4">User satisfaction with provided recommendations</li>
        <li class="pt-4">Suggestions by participants for improving site navigation</li>
        <li class="pt-4">Most and least favorite features of the website</li>
        <li class="pt-4">Comments on the website's visual layout</li>
      </ul>
    </div>
  </section>

  <!-- pizza image -->
  <div class="flex flexmobile2 justify-center mt-10 md:mt-24">
    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/de764569c98cde895c8a15e3927145583e2ca338a47a44c4bddf113fb9e39dd3?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Chart or graph showing usability test results" class="object-contain animate__animated animate__bounceInDown self-center md:max-w-full aspect-[1.68] w-[300px] md:w-[562px]" />
  </div>
</section>

      <!-- another sec -->
      <section class="z-10 flexmobile2 mx-auto container cursor-fancy  mt-20 md:w-full  max-md:mt-10 max-md:max-w-full">
       <h1 class="self-start text-4xl font-semibold text-white">Top Findings</h1>
        <p class="self-center text-center dancing-script  mt-12 text-3xl text-yellow-400 max-md:mt-10 max-md:max-w-full">
          "This website feels disorganized, clunky, and confusing"
        </p>
        <div  class="flex mt-20 gap-20 max-md:flex-col">
          <article class="flex flex-col w-[447px] max-md:ml-0 max-md:w-full">
            <div class="flex flex-col text-2xl text-white max-md:mt-10 max-md:max-w-full">
              <h3 class=" cardBckground text-xl py-8 font-bold text-center rounded-2xl shadow-[0px_4px_24px_rgba(0,0,0,0.5)]  max-md:max-w-full">
                HIGH SUCCESS RATE
              </h3>
              <ul class="mt-14 list-disc text-xl  max-md:mt-10 max-md:max-w-full">
                <li class="pt-6 text-lg ">All participants completed Task #2 successfully.</li>
                <li class=" pt-6 text-lg ">Task #1 & Task #4 saw reasonable success (5 out of 6)</li>
                <li class=" pt-6 text-lg ">Task #3 saw the most failures (2 out of 6).</li>
                <li class=" pt-6 text-lg ">This indicates that the <span class="text-yellow-400">website does work as intended.</span></li>
              </ul>
            </div>
          </article>
          <article class="flex flex-col ml-5 w-[447px] max-md:ml-0 max-md:w-full">
            <div class="flex flex-col text-2xl text-white max-md:mt-10 max-md:max-w-full">
             <h3 class=" cardBckground text-xl py-8 font-bold text-center rounded-2xl shadow-[0px_4px_24px_rgba(0,0,0,0.5)]  max-md:max-w-full">
                LOW SATISFACTION
              </h3>
              <ul class="mt-14 list-disc text-xl  max-md:mt-10 max-md:max-w-full">
                <li class="pt-6 text-lg ">Participants' satisfaction with the results was low.</li>
                <li class="pt-6 text-lg ">Most settled for a recommendation found in the 1st or second relevant article they browsed.</li>
                <li class="pt-6 text-lg ">The <span class="text-yellow-400">lack of filters</span> meant they were settling for an acceptable but <span class="text-yellow-400">less-than-ideal recommendation.</span></li>
              </ul>
            </div>
          </article>
          <article class="flex flex-col ml-5 w-[447px] max-md:ml-0 max-md:w-full">
            <div class="flex flex-col grow text-2xl text-white max-md:mt-10 max-md:max-w-full">
              <h3 class=" cardBckground text-xl py-8 font-bold text-center rounded-2xl shadow-[0px_4px_24px_rgba(0,0,0,0.5)]  max-md:max-w-full">
                DIFFICULTY
              </h3>
              <ul class="mt-14 list-disc text-xl  max-md:mt-10 max-md:mr-1 max-md:max-w-full">
                <li class=" pt-6 text-lg ">Participants found Task #1 and Task #3 the <span class="text-yellow-400">hardest</span> to complete.</li>
                <li class=" pt-6 text-lg ">For Task #1, they were shown <span class="text-yellow-400">irrelevant information.</span></li>
                <li class=" pt-6 text-lg ">For Task #3 they had <span class="text-yellow-400">no means to search by multiple criteria</span> simultaneously.</li>
                <li class=" pt-6 text-lg ">Task #2 was the easiest as the most relevant article was at the top of the list of results.</li>
              </ul>
            </div>
          </article>
        </div>
      </section>



     
      <div class="flex flexmobile2 mt-14 md:mt-16 flex-col items-center rounded-none">
        <!-- participation -->
        <div class="flex flexmobile2 md:mt-56 flex-col items-center rounded-none">
 




         <section class=" px-4 md:px-20 mt-10 md:mt-56 mx-auto">
  <section class="md:w-full">
    <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white">Participant Opinions</h1>
     <blockquote class="dancing-script self-center mb-16 mt-20 ml-4 text-3xl font-medium text-center text-yellow-400 max-md:mt-10 max-md:text-xl max-md:max-w-full">
      "I would recommend it more for interesting content to read rather than a primary tool for finding recommendations, especially when pressed for time."
    </blockquote>
    <div class="flex flex-col md:flex-row justify-between md:gap-10">
      
      
      <div class="w-full md:w-[45%] ml-12">
        <section class="flex flex-col">
          <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6">WHAT THEY DID NOT LIKE</p>
          <ul class=" text-white pt-6 text-lg ">
            <li class="pt-6 text-lg ">Confusing navigation bar</li>
            <li class="pt-6 text-lg ">Glitches that redirected to the main Eater website</li>
            <li class="pt-6 text-lg ">Lack of tabs led to the use of 'search' for everything</li>
            <li class="pt-6 text-lg ">Lack of filters resulting in irrelevant information and endless scrolling</li>
            <li class="pt-6 text-lg ">Tasks took longer than estimated</li>
            <li class="pt-6 text-lg ">Experience was marred and interrupted by ads</li>
          </ul>
        </section>
      </div>
      
      <!-- Hidden Image on Mobile -->
      <div class="hidden md:block  ">
        <img src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726676159/Line_1_fhhb8m.png" alt="" class="hiddenn max-md:block max-md:my-5">
      </div>
      

      <div class="w-full md:w-[45%] mt-10 md:mt-0">
        <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6">WHAT THEY LIKED</p>
        <ul class=" text-white pt-6 text-lg md:pb-6">
          <li class="pt-6 text-lg ">Quick links to recommended restaurant websites and social media handle</li>
          <li class="pt-6 text-lg ">Interactive map along with recommendations as a means to browse options</li>
          <li class="pt-6 text-lg ">Appreciated the passion for food displayed by the articles’ writing</li>
          <li class="pt-6 text-lg ">Felt reassured that the writers articles were Chicago based</li>
        </ul>
      </div>
      
    </div>
  </section>
</section>






  <!-- Other sections with similar adjustments -->
  <!-- Make sure to apply max-md breakpoints and text adjustments similarly across all sections -->
</div>
      <section class="flex flexmobile2 background-1566 flex-col items-center self-stretch px-20 pt-24 pb-56 mt-32 w-full max-md:px-5 max-md:pb-24 max-md:mt-10 max-md:max-w-full">
        <div class=" container mx-auto">
          <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white">Recommendations</h1>
            <ul class=" text-white pt-6 text-lg md:pb-6">
          <li class="pt-6 text-lg ">Having <span class="text-yellow-400">relevant search criteria</span> in the main navigation header such as the existing <span class="text-yellow-400">'neighborhoods'</span>, along with <span class="text-yellow-400">'budget', 'ambiance',</span> <span class="text-yellow-400">'reservations'</span>, and <span class="text-yellow-400">'timings'</span> (lunch, dinner, and brunch specials)</li>
          <li class="pt-6 text-lg "> The ability to <span class="text-yellow-400">filter results</span> by these criteria should also be an included feature</li>
          <li class="pt-6 text-lg ">Providing important information for each featured restaurant such as <span class="text-yellow-400">address, timings, estimated cost for two, etc</span>. can help users make more informed and thus satisfying decisions.</li>
          <li class="pt-6 text-lg ">Update the <span class="text-yellow-400">search algorithm</span> to find articles based on <span class="text-yellow-400">keywords</span> entered.</li>
          <li class="pt-6 text-lg "><span class="text-yellow-400">Exclude mentions of restaurants in cities other than Chicago.</span></li>
          </ul>
        </div>
      </section>
      <!-- last cards -->
      <section class="flex flex-col items-center mt-24 w-full max-md:mt-10 max-md:max-w-full">
        <div class="flex flex-wrap gap-6 max-w-full text-2xl font-bold text-center text-white  ">
          <h3 class="grow cardBckground px-16 py-8 w-[443px] whitespace-nowrap rounded-2xl shadow-[0px_4px_24px_rgba(0,0,0,0.5)] max-md:px-5 max-md:max-w-full">
            FEATURE
          </h3>
          <h3 class="grow cardBckground px-16 py-8 rounded-2xl shadow-[0px_4px_24px_rgba(0,0,0,0.5)] w-[686px] max-md:px-5 max-md:max-w-full">
            LEVEL OF URGENCY/ IMPORTANCE (1-5)
          </h3>
        </div>
        <div class="flex flex-wrap gap-4 mt-4 max-w-full font-bold text-center text-white w-fit ">
          <div class="grow px-16 py-9 text-2xl rounded-2xl border border-solid bg-white bg-opacity-0 border-stone-100 shadow-[0px_4px_10px_rgba(246,238,191,1)] w-[443px] max-md:px-5 max-md:max-w-full">
            Navigation Header Design
          </div>
          <div class="grow px-16 py-7 text-3xl whitespace-nowrap rounded-2xl border border-solid bg-white bg-opacity-0 border-stone-100 shadow-[0px_4px_10px_rgba(246,238,191,1)] w-[686px] max-md:px-5 max-md:max-w-full">
            3
          </div>
        </div>
        <div class="flex flex-wrap gap-4 mt-3.5 max-w-full font-bold text-center text-white ">
          <div class="grow px-14 py-9 text-2xl rounded-2xl border border-solid bg-white bg-opacity-0 border-stone-100 shadow-[0px_4px_10px_rgba(246,238,191,1)] w-[443px] max-md:px-5 max-md:max-w-full">
            Filter and Sort search results
          </div>
          <div class="grow px-16 py-7 text-3xl whitespace-nowrap rounded-2xl border border-solid bg-white bg-opacity-0 border-stone-100 shadow-[0px_4px_10px_rgba(246,238,191,1)] w-[686px] max-md:px-5 max-md:max-w-full">
            5
          </div>
        </div>
        <div class="flex flex-wrap gap-4 mt-3.5 max-w-full font-bold text-center text-white ">
          <div class="grow px-8 py-9 text-2xl rounded-2xl border border-solid bg-white bg-opacity-0 border-stone-100 shadow-[0px_4px_10px_rgba(246,238,191,1)] w-[443px] max-md:px-5 max-md:max-w-full">
            Updating Restaurant Information
          </div>
          <div class="grow px-16 py-7 text-3xl whitespace-nowrap rounded-2xl border border-solid bg-white bg-opacity-0 border-stone-100 shadow-[0px_4px_10px_rgba(246,238,191,1)] w-[686px] max-md:px-5 max-md:max-w-full">
            2
          </div>
        </div>
        <div class="flex flex-wrap gap-4 mt-3.5 max-w-full font-bold text-center text-white ">
          <div class="grow px-16 py-9 text-2xl rounded-2xl border border-solid bg-white bg-opacity-0 border-stone-100 shadow-[0px_4px_10px_rgba(246,238,191,1)] w-[443px] max-md:px-5 max-md:max-w-full">
            Improve Search Algorithm
          </div>
          <div class="grow px-16 py-7 text-3xl whitespace-nowrap rounded-2xl border border-solid bg-white bg-opacity-0 border-stone-100 shadow-[0px_4px_10px_rgba(246,238,191,1)] w-[686px] max-md:px-5 max-md:max-w-full">
            5
          </div>
        </div>
      </section>
      <!-- last but not least  -->
      <section class=" flex conatiner mx-auto flexmobile2 gap-2 justify-between mt-56 max-md:mt-10">

      <div class="text-white text-base md:w-1/2 ml-20">
       <h1 class="font-semibold pt-10 md:pt-20 text-2xl md:text-4xl">Going Forward</h1>
         <ul class=" text-white pt-6 text-lg md:pb-6">
          <li class="pt-6 text-lg ">Devise a <span class=" text-yellow-300">test plan for an updated version of Eater Chicago</span> that has incorporated desired features and addressed common participant complaints.</li>
          <li class="pt-6 text-lg ">This round of testing will <span class=" text-yellow-300">focus on the effectiveness of the implemented design</span> recommendations with <span class=" text-yellow-300">user satisfaction</span> being a key performance indicator.</li>
          <li class="pt-6 text-lg ">A <span class=" text-yellow-300">larger subject pool</span> will also be recruited to assure consistent and good quality data.</li>
          <li class="pt-6 text-lg ">While the tasks used in this test can be repeated, additional tasks can be devised to <span class=" text-yellow-300">test user retention</span> using the <span class=" text-yellow-300">number of articles browsed as a key performance indicator.</span></li>
          </ul>
      </div>

       <div >
        <img src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677060/Subject_52_qkxp4h.png" alt="">
       </div>
      </section>

      <div class="">
        <a
            href="https://online.fliphtml5.com/kqzee/muny/#p=1"
              class="flex   relative p-10  bgColorr    md:w-46 h-12 text-center text-xl rounded-[80px] shadow-[0px_4px_24px_rgba(0,0,0,0.5)]"
            >
              <span class="grow text-white relative bottom-4 text-center ">Access Project Report</span>
            </a>
      </div>

      <!-- last project section -->
      <section class=" flex flexmobile md:mb-44 px-20 mx-auto container relative md:top-60 justify-center flex-col flex-wrap mt max-md:mt-10">
        <h2 class="text-4xl text-center font-semibold pt-10 text-white">View other Projects</h2>
        <div class="self-start mt-2 ml-4 max-md:max-w-full">
          <div class="flex justify-center  gap-5 max-md:flex-col">
            <article class="flex  w-full max-md:ml-0 max-md:w-full">
              <div class="pb-12 flex flex-col md:flex-row justify-between items-center font-bold text-white rounded-[50px] max-md:px-5 max-md:mt-10 max-md:max-w-full">
    <router-link to="LorealProject">
        <div class="flex m cursor-pointer relative z-10 w-full max-w-full max-md:w-full max-md:h-auto">
            <img class="w-full h-full object-cover" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677110/Group_34201_1_etg3lv.png" alt="">
        </div>
    </router-link>
    <router-link to="SubscriptionManagement">
        <div class="cursor-pointer md:pt-16 relative z-10 ">
            <img class="w-full  h-full object-cover" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677101/Group_34200_1_uhcpsd.png" alt="">
        </div>
    </router-link>
</div>
            </article>
          </div>
        </div>
      </section>
    
    </div>
    </div>
  </template>
  
  <script>
  export default {
   name:'FirstProjectwrok',
   data() {
    return {
      imageUrl: 'https://cdn.builder.io/api/v1/image/assets/TEMP/7a26e3a6d57bcfbab123454e7ff80c6b70bc0cd185149e1d7ec9d1831785e382?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b',
      animateClass: '', // This will be updated when the image is in view
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animateClass = 'animate__animated animate__flash';
          }
        });
      },
      {
        threshold: 0.1, // Adjust this threshold if needed
      }
    );
    observer.observe(this.$refs.imageContainer);
  },
};
 
  </script>
 
 <style>

@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&display=swap');
 @media (max-width:740px) {
  .background-1565{
  background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726673828/Rectangle_4156_lwbdrk.png");
  background-size:contain;
  background-repeat: no-repeat;
 }
 }
.background-1565{
  background: linear-gradient(180deg, rgba(229, 4, 4, 0.70) 0%, rgba(122, 9, 9, 0.60) 47.7%, rgba(69, 12, 12, 0.70) 71.56%, rgba(42, 13, 13, 0.80) 83.48%, rgba(28, 13, 13, 0.95) 89.44%, #0F0E0E 95.41%);
 }
 .background-1566{
  background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726673905/eatrySecoundback_l9q9h1.png");
  background-size:cover;
  background-repeat: no-repeat;
 }
 .background-4198{
  background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1727034294/Group_34249_1_vipnjm.png");
  background-size:cover;
  background-repeat: no-repeat;
 }
 .garyaBg{
  background-color: #0F0E0E;
  background-image: none;
  }
  .list-dotted {
  list-style-type: disc;
  list-style-position: inside;
  counter-increment: none; /* Prevent numbering */
}
.cardBckground {
  background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677286/Rectangle_4178_8_bpo615.png");
  height: fit-content;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: box-shadow 0.3s ease; /* Smooth transition for shadow */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Base shadow */
}
@media (max-width:740px) {
  .hiddenn{
    display: none;
  }
  
}
.cardBckground:hover {
  box-shadow: 0 12px 24px rgba(163, 163, 163, 0.5); /* Enhanced shadow for 3D effect */
  
}


</style>

 

